const { styled, Box } = require("@mui/material");

const HeaderBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: "white",
}));

export { HeaderBox };
